import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Landing from "@/pages/Landing";
import BusinessDetail from "@/pages/BusinessDetail";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import Signup from "@/pages/Signup";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";

function AdminRoute({ children }) {
  const { user } = useAuth();
  if (user === null) return <SessionLoading />;
  if (!user || user.role !== "admin") return <Navigate to="/admin/login" replace />;
  return children;
}

function AuthedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) return <SessionLoading />;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function SessionLoading() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-brand-paper">
      <div className="text-brand-muted">Checking session…</div>
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/business/:id" element={<BusinessDetail />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/login" element={<Login />} />
            <Route path="/dashboard" element={<AuthedRoute><Dashboard /></AuthedRoute>} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#FFFAF7",
            border: "1px solid rgba(43,35,38,.13)",
            color: "#2B2326",
            fontFamily: "Hanken Grotesk, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
